// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__-G2WC","insightsList":"newBusinessInsightsMenu_insightsList__1dR89","active":"newBusinessInsightsMenu_active__DPk4I"};